import WPAPI from 'wpapi';

const wp = WPAPI.discover(process.env.REACT_APP_API_ROOT || window.location.origin);

wp.catch((error) => {
    console.log(error); //eslint-disable-line
})


export default wp;


export const getStructure = async () => (
    await wp.then((wp) => (
        wp.namespace("sales_app/v1").data_structure()
    ))
)


export const getOptions = async (optionsID) => (
    await wp.then((wp) => (
        wp.namespace("acf/v3").options().id(optionsID)
    ))
)


export async function getData({ name, fields = 'id,title,slug,acf', max = 100, hierarchical = false }, development = null) {
    const data = await wp.then((wp) => (
        wp[name]()
            .param('_fields', fields)
            .param('development', development)
            .perPage(max)
    ));

    if (hierarchical && Array.isArray(data)) {
        const parents = [];
        const parentsById = {};
        const children = [];

        data.forEach(item => {
            if (item.parent) {
                children.push(item);
            } else {
                parents.push(item);
                parentsById[item.id] = item;
            }
        });

        children.forEach(child => {
            if (parentsById[child.parent]) {
                if (!parentsById[child.parent].children) {
                    parentsById[child.parent].children = [];
                }
                parentsById[child.parent].children.push(child);
            }
        });

        return parents;
    }

    return data;
}
